import React from 'react';
import PropTypes from 'prop-types';
import { Segment, Pagination, Icon } from 'semantic-ui-react';

/**
 * [PaginationSegment description]
 * @param {[type]} activePage   [description]
 * @param {[type]} onPageChange [description]
 * @param {[type]} totalPages   [description]
 */
const PaginationSegment = ({
    activePage, onPageChange, totalPages, removeSegment
}) => (
    !removeSegment ? <Segment>
        <center>
            <Pagination
                activePage={activePage}
                onPageChange={onPageChange}
                totalPages={totalPages}
                ellipsisItem={{ content: <Icon name="ellipsis horizontal" />, icon: true }}
                firstItem={{ content: <Icon name="angle double left" />, icon: true }}
                lastItem={{ content: <Icon name="angle double right" />, icon: true }}
                prevItem={{ content: <Icon name="angle left" />, icon: true }}
                nextItem={{ content: <Icon name="angle right" />, icon: true }}
                siblingRange={0}
                pointing
                secondary
            />
        </center>
    </Segment> :
        <center>
        <Pagination
                activePage={activePage}
                onPageChange={onPageChange}
                totalPages={totalPages}
                ellipsisItem={{ content: <Icon name="ellipsis horizontal" />, icon: true }}
                firstItem={{ content: <Icon name="angle double left" />, icon: true }}
                lastItem={{ content: <Icon name="angle double right" />, icon: true }}
                prevItem={{ content: <Icon name="angle left" />, icon: true }}
                nextItem={{ content: <Icon name="angle right" />, icon: true }}
                siblingRange={0}
                pointing
                secondary
            />
    </center>
);

Pagination.propTypes = {
    activePage: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    totalPages: PropTypes.number.isRequired
};

export default PaginationSegment;



// WEBPACK FOOTER //
// ./src/views/Assets/util/PaginationSegment.js